import { render, staticRenderFns } from "./_CreateVaccination.vue?vue&type=template&id=2bbd754c&scoped=true&"
import script from "./_CreateVaccination.vue?vue&type=script&lang=ts&"
export * from "./_CreateVaccination.vue?vue&type=script&lang=ts&"
import style0 from "./_CreateVaccination.vue?vue&type=style&index=0&id=2bbd754c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bbd754c",
  null
  
)

export default component.exports